import React, { FC, ReactNode, useState } from 'react';
import { Box, BoxProps, TableCellProps, IconButton } from '@mui/material';
import { Delete, Visibility, Cancel, CheckCircle, Undo } from '@mui/icons-material';

import { UpdateUserModal } from './UpdateUserModal';
import { TableProduct } from '../../../components/TableProduct/TableProduct';
import { GetProjectsQuery } from '../../../graphql/query/__generated__/getProjects';
import { useUpdateUserMutation } from '../../../graphql/mutations/__generated__/updateUser';
import { GetUsersDocument, useGetUsersQuery } from '../../../graphql/query/__generated__/getUsers';

interface HeaderCell {
  title: string;
  containerProps?: TableCellProps;
}

interface BoxCell {
  val: string | ReactNode;
  containerProps?: BoxProps;
}
interface TableCellsValue {
  cellsValues: Array<BoxCell>;
}
interface Props {
  data: GetProjectsQuery | undefined;
  getUserId: (event: string) => void;
}

export const UserTable: FC<Props> = ({ getUserId }) => {
  const [runUpdateMutation] = useUpdateUserMutation();
  const { data: dataUsers } = useGetUsersQuery({ variables: { current: false } });

  const [isModalRemove, setIsModalRemove] = useState(false);
  const [getUseId, setGetUserId] = useState('');
  const [getUserStatus, setGetUserStatus] = useState(true);

  const handlerUpdateButton = (id: string, active: boolean): void => {
    setGetUserId(id);
    setIsModalRemove(true);
    setGetUserStatus(active);
  };

  const handleVisibleProjects = (id: string) => {
    getUserId(id);
  };

  const handlerUpdate = async () => {
    try {
      const response = await runUpdateMutation({
        variables: {
          id: getUseId,
          active: getUserStatus ? false : true,
        },
        refetchQueries: [
          {
            query: GetUsersDocument,
            variables: {
              user_id: getUseId,
            },
          },
        ],
      });
      if (response) {
        setIsModalRemove(false);
      }
    } catch (error) {
      console.log('[ERROR]', error);
    }
  };

  const getHeadersTable = (): Array<HeaderCell> => {
    const style: TableCellProps = { color: '#5269A3', align: 'center' };
    return [
      {
        title: 'ID',
        containerProps: { width: '10px', ...style },
      },
      {
        title: 'Имя',
        containerProps: { width: '80px', ...style },
      },
      {
        title: 'Почта',
        containerProps: { width: '220px', ...style },
      },
      {
        title: 'Компания',
        containerProps: { width: '100px', ...style },
      },
      {
        title: 'Город',
        containerProps: { width: '100px', ...style },
      },
      {
        title: 'Роль',
        containerProps: { width: '20px', ...style },
      },
      {
        title: 'Статус',
        containerProps: { width: '20px', ...style },
      },
      {
        title: '',
        containerProps: { width: '20px', ...style },
      },
      {
        title: '',
        containerProps: { width: '20px', ...style },
      },
    ];
  };
  const getRowsTable = (): Array<TableCellsValue> => {
    if (dataUsers && dataUsers?.users?.length) {
      return dataUsers?.users?.map(item => {
        const values: Array<BoxCell> = [];
        values.push({
          val: item.id,
          containerProps: { width: '20px', height: '20px', borderLeft: 'none' },
        });
        values.push({ val: item?.name });
        values.push({ val: item?.email });
        values.push({ val: item?.company });
        values.push({ val: item?.city ? item?.city : '-' });
        values.push({ val: item?.is_admin ? 'Администратор' : 'Пользователь' });

        values.push({
          val: item?.active ? (
            <CheckCircle sx={{ color: '#70BF2B' }} />
          ) : (
            <Cancel sx={{ color: '#DD4646' }} />
          ),
          containerProps: { justifyContent: 'center', width: '20px' },
        });

        values.push({
          val: (
            <IconButton
              aria-label="close"
              color="error"
              sx={{ p: 0.5, color: '#567CF0' }}
              onClick={() => handleVisibleProjects(item?.id)}
            >
              <Visibility />
            </IconButton>
          ),
          containerProps: { justifyContent: 'center', width: '20px' },
        });

        values.push({
          val: (
            <IconButton
              aria-label="close"
              color="error"
              sx={{ p: 0.5, color: '#567CF0' }}
              onClick={() => handlerUpdateButton(item?.id, item?.active)}
            >
              {item?.active ? <Delete /> : <Undo />}
            </IconButton>
          ),
          containerProps: { borderLeft: 'none', justifyContent: 'center' },
        });

        return { cellsValues: values };
      });
    }
    return [];
  };
  return (
    <Box boxSizing="border-box" width="100%">
      <TableProduct itemsRows={getRowsTable()} itemsHeader={getHeadersTable()} />
      {isModalRemove && (
        <UpdateUserModal
          getUserStatus={getUserStatus}
          handlerUpdate={handlerUpdate}
          closeModal={() => setIsModalRemove(false)}
        />
      )}
    </Box>
  );
};
export default UserTable;
